import type { MailboxInfo } from 'owa-client-types';
import { getAccountScopeUserSettings } from './getAccountScopeUserSettings';
import isConsumer from '../utils/isConsumer';

const PREMIUM_CONSUMER_OPTION = 'PremiumConsumerSetting';

export default function isPremiumConsumer(mailboxInfo: MailboxInfo): boolean {
    if (!isConsumer(undefined, mailboxInfo)) {
        return false;
    }

    const settings = getAccountScopeUserSettings(mailboxInfo);
    if (settings.SessionSettings?.IsPremiumConsumerMailbox) {
        return true;
    }

    const primeSettingsItems = settings.PrimeSettings?.Items;
    const primePremiumConsumerSetting: any = primeSettingsItems?.filter(
        item => item?.Id === PREMIUM_CONSUMER_OPTION
    );
    return primePremiumConsumerSetting?.[0]?.Value ?? false;
}
